import type {
  Codespace,
  FetchCodespaceListParams
} from 'Services/ControlDataManagement/Features/Codespace/types'
import type { ListResponse } from 'Services/ControlDataManagement/types'
import { createBaseApi } from 'Util/ApiClient'

const CODESPACE_TAG_TYPE = 'Codespace'

export const codespaceApi = createBaseApi({
  reducerPath: 'codespaceApi',
  keepUnusedDataFor: 5,
  tagTypes: [CODESPACE_TAG_TYPE]
}).injectEndpoints({
  endpoints: builder => ({
    getCodespaces: builder.query<ListResponse<Codespace>, FetchCodespaceListParams | undefined>({
      query: params => ({
        url: '/api/v1/codespace/',
        params
      }),
      providesTags: result =>
        result
          ? [
              ...result.resources.map(({ id }) => ({ type: CODESPACE_TAG_TYPE, id }) as const),
              { type: CODESPACE_TAG_TYPE, id: 'LIST' }
            ]
          : [{ type: CODESPACE_TAG_TYPE, id: 'LIST' }]
    }),
    getSingleCodespace: builder.query<Codespace, string>({
      query: id => `/api/v1/codespace/${id}/`,
      providesTags: (_result, _error, id) => [{ type: CODESPACE_TAG_TYPE, id }]
    }),
    createSingleCodespace: builder.mutation<Codespace, Partial<Codespace>>({
      query: data => ({
        url: `/api/v1/codespace/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: [{ type: CODESPACE_TAG_TYPE, id: 'LIST' }]
    }),
    updateSingleCodespace: builder.mutation<
      Codespace,
      { codespace_id: string } & Partial<Codespace>
    >({
      query: ({ codespace_id, ...data }) => ({
        url: `/api/v1/codespace/${codespace_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: CODESPACE_TAG_TYPE, id }]
    }),
    deleteSingleCodespace: builder.mutation<Record<string, never>, string>({
      query: id => ({
        url: `/api/v1/codespace/${id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: [{ type: CODESPACE_TAG_TYPE, id: 'LIST' }]
    })
  })
})

export const {
  useGetCodespacesQuery,
  useLazyGetCodespacesQuery,
  useGetSingleCodespaceQuery,
  useCreateSingleCodespaceMutation,
  useUpdateSingleCodespaceMutation,
  useDeleteSingleCodespaceMutation
} = codespaceApi
